import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeIsMainMenuOpened, changeLanguage, saveConfiguration, setIsLoadingUnitStatus, setPopupState,
} from '../../model/configuratorSlice';
import { CloseButton } from '../../shared/svg/components';
import {
 ClientsPageTestingUrl, ClientsPageUrl, Language, PopupState, ServerBaseUrl,
} from '../../model/constants';
import IsNullOrUndefined from '../../utils/ObjectUtils';
import { TranslationUtility } from '../../utilities/TranslationUtility';

const MainMenu = () => {
    const {
        isMainMenuOpened, user, currentUnit,
    } = useSelector(state => state.configurator);
    const dispatch = useDispatch();

    const openClientsPage = () => {
        const clientsPageUrl = ServerBaseUrl.includes('localhost') ? ClientsPageTestingUrl : ClientsPageUrl;
        window.open(clientsPageUrl, '_self', 'noreferrer');
    };

    return (
      <div className={`main-menu ${isMainMenuOpened ? 'opened' : ''}`}>
        <button
          className={`background ${isMainMenuOpened ? 'opened' : ''}`}
          type="button"
          aria-label="Close menu"
          onClick={() => dispatch(changeIsMainMenuOpened(false))}
        />
        <div className={`panel ${isMainMenuOpened ? 'opened' : ''}`}>
          <button
            type="button"
            className="close-button"
            onClick={() => dispatch(changeIsMainMenuOpened(false))}
          >
            <CloseButton />
          </button>
          <div className="main-menu-content">
            {!IsNullOrUndefined(currentUnit) ? <div className="flat-name">{currentUnit.name}</div> : null}
            {!IsNullOrUndefined(user) ? (
              <div className="user-name">{user.name}</div>
            ) : null}
            <div className="account-container">
              {IsNullOrUndefined(currentUnit) ? (
                <>
                  <button
                    className="menu-button-login"
                    type="button"
                    onClick={() => {
                        dispatch(changeIsMainMenuOpened(false));
                        openClientsPage();
                    }}
                  >Iniciar sesión
                  </button>
                </>
                            )
                            : (
                              <>
                                <button
                                  className="menu-button-logout"
                                  type="button"
                                  onClick={() => {
                                            dispatch(changeIsMainMenuOpened(false));
                                            dispatch(setPopupState(PopupState.Logout));
                                        }}
                                >
                                  {TranslationUtility.GetFormattedMessageForUI('ui-button-logout', 'Cerrar Sesión')}
                                </button>
                              </>
                            )}
            </div>
            <div className="menu-buttons-container">
              <button
                className="menu-button"
                type="button"
                hidden={IsNullOrUndefined(currentUnit)}
                onClick={() => {
                  dispatch(setIsLoadingUnitStatus(true));
                  dispatch(setPopupState(PopupState.CheckForSaveConfiguration));
                  dispatch(changeIsMainMenuOpened(false));
                }}
              >
                {TranslationUtility.GetFormattedMessageForUI('ui-button-save-configuration', 'Guardar Configuración')}
              </button>
              {!IsNullOrUndefined(user) && user.units.length > 1 ? (
                <button
                  className="menu-button"
                  type="button"
                  onClick={() => {
                    dispatch(changeIsMainMenuOpened(false));
                    dispatch(setPopupState(PopupState.UnitSelector));
                  }}
                >
                  {TranslationUtility.GetFormattedMessageForUI('ui-button-unit-selector',
                    'Selección de Vivienda')}
                </button>
              ) : null}
            </div>

          </div>
        </div>
      </div>
    );
};

export default MainMenu;
